import React from 'react';
import { graphql, StaticQuery } from 'gatsby';
import { Layout, siteName, pageTypes, AdMobileAnchor, AdMobileBanner, AdLeaderboard, AdVideo } from 'gatsby-theme-apollo';
import GameContent from '../templates/page/content';
import PostPreviewCards from '../templates/cards/post-preview-card';
import Section from '../templates/layout/section';
import Footer from '../templates/page/footer';
import { sortPostsByDate } from '../util/sort';
import { filterLowQualityPosts } from '../util/filter';

const News = ({ location }) => {
  const pageType = pageTypes.POST_HUB;
  const pageTitle = `News | ${siteName}`;

  return (
    <StaticQuery
      query={graphql`
        {
          cms {
            posts(where: { publish_ne: "false" }, sort: "createdAt:DESC") {
              page
              title
              subtitle
              publish
              author {
                name
                id
              }
              createdAt
              contentJSON
              publishedDate
              headerURI
              featured
              games {
                name
              }
              headerImage {
                url
              }
            }
          }
        }
      `}
      render={queryData => {
        let publishedPostPreviews =
          queryData &&
          queryData.cms.posts;
        publishedPostPreviews = sortPostsByDate(filterLowQualityPosts(publishedPostPreviews.filter(post => !post.page)));

        return (
          <Layout location={location} title={pageTitle} pageType={pageType}>
            <AdMobileAnchor placementId={'gh-anchor-' + pageType +'-bottom'} anchorType='bottom' offset='0' />
            <GameContent hideMobile>
              <Section title="Guides" />
              <AdMobileBanner placementId={"gh-mobilebanner-" + pageType + "-top"} />
              <AdLeaderboard placementId={"gh-leaderboard-" + pageType + "-top"} />
              <PostPreviewCards postPreviews={publishedPostPreviews} limit={24} />
              <AdVideo placementId={'gh-video-' + pageType + '-floating'} />
              <Footer />
            </GameContent>
          </Layout>
        );
      }}
    />
  );
};

export default News;
